$(document).ready(function () {

let lenis = null;

if (!document.body.classList.contains('template-product')) {

  lenis = new Lenis();

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }

  requestAnimationFrame(raf);

  $('.header__icon').on('click', function () {

    if ($(window).width() > 768) return;

    if (!lenis) return;

    if ($('body').hasClass('lenis-disabled')) {
      lenis.start();
      $('body').removeClass('lenis-disabled');
    } else {
      lenis.stop();
      $('body').addClass('lenis-disabled');
    }

  });

}

  // $('.cs-slider').slick({
  //   slidesToShow: 3,
  //   slidesToScroll: 1,
  //   arrows: true,
  //   dots: true,
  //   autoplay: false,
  //   adaptiveHeight: true,
  //   responsive: [
  //     {
  //       breakpoint: 1024,
  //       settings: { slidesToShow: 2 }
  //     },
  //     {
  //       breakpoint: 768,
  //       settings: { slidesToShow: 1 }
  //     }
  //   ]
  // });


});

  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    if (scroll >= 50) {
      $("header").addClass("scrolled");
    } else {
      $("header").removeClass("scrolled");
    }
  });











$(document).on('click', '.col-drop', function() {
  $(this).toggleClass('act');
	$('.collection-inner-wrap').toggleClass('open');	
});

var btn = $('#backtop');

$(window).scroll(function() {
  if ($(window).scrollTop() > 300) {
    btn.addClass('show');
  } else {
    btn.removeClass('show');
  }
});

btn.on('click', function(e) {
  e.preventDefault();
  $('html, body').animate({scrollTop:0}, '300');
});

